import { Like } from '@sparemin/blockhead';
import styled from 'styled-components';

export const DislikeIcon = styled(Like)`
  transform: scale(1, -1);
`;
